<template>
  <div>
    <el-dialog
      v-if="show"
      v-dialogStyle
      class="abow_dialog"
      title="特品详细信息列表"
      destroy-on-close
      :visible.sync="show"
      center
      :append-to-body="true"
      :lock-scroll="false"
      width="70%"
      @close="close()">
      <taskDetails :rowdata="rowdata"></taskDetails>
    </el-dialog>
    <DataTable
      :table-data="tableData"
      :table-label="tableLabel"
      :config="config"
      @searchTable="getTaskState()"
      @dateChangeEvent="getTaskState()"
      @rowDblclick="rowDblclick"
      @clearSearch="clearSearch">
    </DataTable>
    <DataPagination
      :config="config"
      @sizeChange="handleSizeChange"
      @currentChange="handleCurrentChange">
    </DataPagination>
  </div>
</template>
<script>
import DataTable from '../../../components/pageComponent/DataTable'
import taskDetails from './taskDetails.vue'
import DataPagination from '../../../components/pageComponent/DataPagination'
import './dialogStyle.js'
export default {
  components: {
    DataTable,
    taskDetails,
    DataPagination
  },
  data() {
    return {
      rowdata: [],
      show: false,
      param: '',
      searchFlag: false,
      config: {
        sizes: [15, 25, 35],
        dataTotalCount: 0,
        pageSize: 15,
        currentPage: 1,
        fixed: true,
        loading: false,
        searchTables: true,
        height: '82vh',
        indexWidth: '85%'
      },
      tableData: [],
      tableLabel: [
        {
          label: '份合同号',
          prop: 'orderNo',
          fixed: true,
          search: ''
        },
        {
          label: '特品单号',
          prop: 'specailProductCode',
          search: ''
        },
        {
          label: '合同小号',
          prop: 'subOrderNo',
          search: ''
        },
        {
          label: '特品类型',
          prop: 'productClass',
          search: ''
        },
        {
          label: '产品型号',
          prop: 'productType',
          search: ''
        },
        {
          label: '分配部门',
          prop: 'departName',
          search: ''
        },
        {
          label: '计划开始时间',
          prop: 'planStartTime',
          search: '',
          type: 'Date'
        },
        {
          label: '计划结束时间',
          prop: 'planFinishTime',
          search: '',
          type: 'Date'
        },
        {
          label: '合同交期',
          prop: 'finishStamp',
          search: '',
          type: 'Date'
        },
        {
          label: '特品签发时间',
          prop: 'tp_date',
          search: '',
          type: 'Date'
        },
        {
          label: '实际结束时间',
          prop: 'remainingFinishTime',
          search: '',
          type: 'Date',
          isShow: 'false'
        },
        {
          label: '是否超期',
          prop: 'flag',
          search: ''
        },
        {
          label: '任务状态',
          prop: 'status',
          search: ''
        }
      ]
    }
  },
  mounted() {
    this.getTaskState()
  },
  methods: {
    //清空搜索
    clearSearch() {
      const that = this
      for (const a in that.tableLabel) {
        that.tableLabel[a].search = ''
      }
      this.getTaskState()
    },
    //搜索
    searchTable() {
      const that = this
      const obj = {}
      for (const a in that.tableLabel) {
        if (that.tableLabel[a].search) {
          if (that.tableLabel[a].type === 'Date') {
            const start = that.tableLabel[a].prop + 'Start'
            const end = that.tableLabel[a].prop + 'End'
            obj[start] = that.tableLabel[a].search[0]
            obj[end] = that.tableLabel[a].search[1]

          } else {
            obj[that.tableLabel[a].prop] = that.tableLabel[a].search
          }

        }
      }
      return obj
    },
    getTaskState() {
      const obj = this.searchTable()
      if (JSON.stringify(obj) !== '{}') {
        this.config.currentPage = 1
      }
      const data = {
        limit: this.config.currentPage,
        currentPage: this.config.pageSize
      }
      Object.assign(data, obj)
      this.config.loading = true

      var name = this.$route.params.name
      if (name === '进行中') {
        this.$post('/fesback/taskState/taskInProgress.z', data).then(response => {
          //关闭遮罩层
          this.config.loading = false
          if (response === '') {
            this.tableData = []
            this.config.dataTotalCount = 0
          } else {
            this.tableData = response
            this.config.dataTotalCount = response[0].count
          }
        }).catch(function(error) {
          //关闭遮罩层
          this.config.loading = false
        })
      } else if (name === '已完成') {
        this.tableLabel[10].isShow = null
        this.$post('/fesback/taskState/taskCompleted.z', data).then(response => {
          //关闭遮罩层
          this.config.loading = false
          if (response === '') {
            this.tableData = []
            this.config.dataTotalCount = 0
          } else {
            this.tableData = response
            this.config.dataTotalCount = response[0].count
          }
        }).catch(function(error) {
          //关闭遮罩层
          this.config.loading = false
        })
      }
    },
    rowDblclick(row, column, event) {
      this.rowdata = row
      this.show = true
    },
    close() {
      this.show = false
    },
    handleSizeChange(size) {
      // this.clearSearch()
      this.config.pageSize = size
      this.getTaskState()
    },
    // 控制页面的切换
    handleCurrentChange(currentpage) {
      this.config.currentPage = currentpage
      this.getTaskState()
    }
  }
}
</script>
<style scoped>
  .abow_dialog {
    display: flex;
    justify-content: center;
    align-items: Center;
    overflow: hidden
  }
</style>
